import { FC, useState, useEffect } from 'react';
import { LangText } from '../textLang';
import styles from './index.module.scss';
import Emarsys from './EmarsysConf';
import { emailMap } from '@/constants/appreciationDay';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';

interface BannerEmailProps {
    data: any;
}

const BannerEmail: FC<BannerEmailProps> = ({ data }) => {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const [open, setOpen] = useState(false);
    const emailConf = emailMap[locale] || emailMap.us;
    const langTxt = LangText[locale] || LangText['us'];
    const { align, isDefaultChecked } = data;
    const [check, setCheck] = useState<boolean>(isDefaultChecked === 'Y');
    const [showErrorTips, setShowErrorTips] = useState<boolean>(false);
    const [tipsMessage, setTipsMessage] = useState<string>('');
    const [tipsType, setTipsType] = useState<string>('error');

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: LangText[locale].btn,
                status: 'success',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: LangText[locale].btn,
            status: 'fail',
        });
    };

    const handleCheck = (e: any) => {
        if (!e.target.checked) {
            setShowErrorTips(true);
        } else {
            setShowErrorTips(false);
        }
        setCheck(e.target.checked);
    };

    useEffect(() => {
        if (isDefaultChecked === 'Y') {
            setCheck(true);
        } else if (isDefaultChecked === 'N') {
            setCheck(false);
        }
    }, [isDefaultChecked]);

    return (
        <>
            <>
                <Emarsys
                    emarsysFields={data.emarsysFields}
                    source={emailConf.source}
                    submitText={langTxt.btn}
                    placeholder={langTxt.emailPlace}
                    successCallback={successCallBack}
                    errorCallback={errorCallback}
                    align={align}
                    isChecked={check}
                    setShowErrorTips={setShowErrorTips}
                    setTipsMessage={setTipsMessage}
                    setTipsType={setTipsType}
                />
                {tipsMessage && <div className={`show-tips ${tipsType}`}>{tipsMessage}</div>}
                <div className="terms-use-box">
                    <input id="member-email-checkbox" type="checkbox" className="checkbox" checked={check} onChange={handleCheck} />
                    <label htmlFor="member-email-checkbox" className="terms-use" dangerouslySetInnerHTML={{ __html: langTxt.protocol }}></label>
                </div>
                {showErrorTips && <div className="is-error-tips">{langTxt.protocol_error_tips}</div>}
            </>

            {/* 订阅弹窗 */}
            <EfModal
                className={`${styles.subscribe_modal}`}
                width={812}
                onCancel={() => {
                    setOpen(false);
                }}
                zIndex={999}
            >
                <div className="content">
                    <h6>{langTxt.success_title}</h6>
                    <p>{langTxt.success_desc}</p>
                </div>
            </EfModal>
        </>
    );
};

export default BannerEmail;
